import { LanguageContextProvider } from "../../../components/LanguageContext/LanguageContext";
import WordpressApi, { Menus } from "../../../services/wordpressApi";
import Composer from "../../sprachschule-faq-deutschsprachkursesprachpruefungen/index";

export default function LanguageComposer(props: any) {
  return (
    <LanguageContextProvider lang={props.lang}>
      <Composer {...props} />
    </LanguageContextProvider>
  );
}
export async function getServerSideProps({ params: { slug } }: any) {
  let data: any;
  let menus = {};
  let faqList = [];
  let faqCategory = [];
  let htmlHeader = "";
  try {
    [data, menus, faqCategory, faqList] = await Promise.all([
      WordpressApi.getPage("lcl-faq-german-language-school", "en"),
      WordpressApi.getMenus("en"),
      WordpressApi.getFAQCategory("en"),
      WordpressApi.getFAQ(slug, "en"),
    ]);
  } catch (error) {
    console.log(error);
    return {
      notFound: true,
    };
  }

  return {
    props: {
      lang: "en",
      data: data && data.blocks ? data.blocks : [],
      tags: data && data.tags ? data.tags : [],
      breadcrumbs: data && data.breadcrumbs ? data.breadcrumbs : [],
      header: data?.header || "",
      htmlHead: data && data.htmlHead ? data.htmlHead : "",
      menus,
      faqCategory,
      faqList,
    },
  };
}
